import { createFileRoute, redirect } from '@tanstack/react-router';
import { ReviewCenter } from '@/components/ReviewCenter/ReviewCenter';

export const Route = createFileRoute('/review-center/')({
  beforeLoad: ({ context }) => {
    const { user, authLoading } = context as { user: unknown; authLoading: boolean };
    if (authLoading) return;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
  component: ReviewCenterPage,
});

function ReviewCenterPage() {
  return <ReviewCenter />;
}
